(function () {
  'use strict';

  angular.module('unit.interested.leads', ['ngResource']);
})();
